export default "__VITE_ASSET__3TEM8g2I__"